import Card from "./Card";
import { cv } from "./data";
import "./resume.css";

const Resume = () => {
  return (
    <section className="resume section" id="resume">
      <h2 className="section__title text-cs">Experiences</h2>
      <p className="section__subtitle">My Journey</p>
      <div className="resume__container container">
        {/* <div className="resume__group ">
          <h3 className="resume__heading">
            <span>Education</span>
          </h3>
          <div className="resume__items ">
            {cv.map((val, id) => {
              if (val.category === "education") {
                return (
                  <Card
                    key={id}
                    title={val.title}
                    subtitle={val.subtitle}
                    date={val.date}
                    description={val.description}
                  />
                );
              }
              return null;
            })}
          </div>
        </div> */}

        <div className="resume__group ">
          {/* <h3 className="resume__heading resume__heading__exp">
            <span>Experience</span>
          </h3> */}
          <div className="resume__items ">
            {cv.map((val, id) => {
              if (val.category === "experience") {
                return (
                  <Card
                    key={id}
                    idx={id}
                    title={val.title}
                    subtitle={val.subtitle}
                    date={val.date}
                    description={val.description}
                  />
                );
              }
              return null;
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
